import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Products from 'merchandise-lib/constants/Product';
import DetailedTermSelector from '../../components/merch-card/terms-display/DetailedTermSelector';
import HSOCMerchCardLayoutUI from './HSOCMerchCardLayoutUI';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const productsConfig = {
  STARTER: {
    apiName: Products.CORE_SEATS_STARTER_HSOC,
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.STARTER.title"
    }),
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.STARTER.description"
    })
  },
  PROFESSIONAL: {
    apiName: Products.CORE_SEATS_PROFESSIONAL_HSOC,
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.PROFESSIONAL.title"
    }),
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.PROFESSIONAL.description"
    })
  },
  ENTERPRISE: {
    apiName: Products.CORE_SEATS_ENTERPRISE_HSOC,
    Title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.ENTERPRISE.title"
    }),
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.merchCards.coreSeats.ENTERPRISE.description"
    })
  }
};
const HSOCMerchCard = ({
  apiName,
  columnStart,
  Badge,
  cardStyles
}) => {
  return /*#__PURE__*/_jsx(HSOCMerchCardLayoutUI, {
    "data-selenium-id": `${apiName}-merch-card`,
    columnStart: columnStart,
    Badge: Badge,
    Title: productsConfig.STARTER.Title,
    Subheading: productsConfig.STARTER.Subheading,
    Pricing: '$9/per seat per month',
    Term: /*#__PURE__*/_jsx(DetailedTermSelector, {
      apiName: apiName,
      trackingSource: 'merch-card'
    }),
    CTAs: /*#__PURE__*/_jsx("div", {
      children: "CTA Button"
    }),
    Subtext: /*#__PURE__*/_jsxs(View, {
      borderInlineStartColor: "border-core-subtle",
      borderInlineStartWidth: "100",
      borderInlineStartStyle: "solid",
      paddingInlineStart: "400",
      children: [/*#__PURE__*/_jsx("div", {
        children: "1,000 included credits /mo"
      }), /*#__PURE__*/_jsx("div", {
        children: "up to 5 users"
      }), /*#__PURE__*/_jsx("div", {
        children: "20K object records"
      })]
    }),
    Features: /*#__PURE__*/_jsx("div", {
      children: "Features List"
    }),
    Footer: 'See more features',
    cardStyles: cardStyles
  });
};
export default HSOCMerchCard;